import jwt_decode from 'jwt-decode';

let domainName = process.env.REACT_APP_APPLICATION_DOMAIN;

const getIdTokenFromCookie = () => {
    let idToken = '';
    let cookieValue = `; ${document.cookie}`;
    let splitCookieByName = [];

    if (cookieValue !== "") {
        splitCookieByName = cookieValue.split(`;`);
        splitCookieByName.forEach((obj) => {
            if (obj[(obj.search("idToken"))] === 'i') {
                let idTokenPositionNo = obj.search("idToken");
                idToken = obj.substr(idTokenPositionNo + 8, obj.length - 1)
            }
        });
    }

    return idToken;
}

const getTokenDetailsByDecoding = () => {
    let token = getIdTokenFromCookie();

    if (token !== '' && token !== undefined && token !== null) {
        let decodedToken = jwt_decode(token);

        let tenantGuid = decodedToken['custom:tenantGuid'];
        let tenantUserGuid = decodedToken['custom:tenantUserGuid'];
        let locationGuid = decodedToken['custom:locationGuid'];
        let currencyGuid = decodedToken['custom:currencyGuid'];
        let tenantUserRole = decodedToken['custom:tenantUserRole'];

        return { tenantGuid, tenantUserGuid, locationGuid, currencyGuid, tenantUserRole };
    } else {
        return null;
    }
}

const readCookieByKeyName = async (key) => {
    let value = '';
    document.cookie.split(';').forEach((e) => {
        if (e.includes(key)) {
            value = e.split('=')[1]
        }
    });

    return value;
}

const deleteCookie = () => {
    document.cookie.split(";").forEach((c) => {
        document.cookie = c
            .replace(/^ +/, "")
            .replace(/=.*/, "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=" + domainName);
    });
}

export {
    getIdTokenFromCookie,
    getTokenDetailsByDecoding,
    deleteCookie,
    readCookieByKeyName
}